export default __webpack_public_path__ + "static/media/logo-wepay4u.22e1b022.svg";